import { executeRequest, Request } from '@jfs/network'
import { Dimensions } from 'react-native'
import { actionMenuStrings } from '../data/static/strings'
import { RootStore } from '../data/store'
import { shouldShowDateForSearch } from '../util/common'
import { dateFormatter, DateFormatTypes, getHHMMSS, isMobile, updateEndDateTimeInRequest } from '../util/util'
import { transactionsParserV3, transactionsParserV3New } from './../network/parsers/TransactionsParser'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'
const responseParser = (
  data: any,
  type: any,
  restrictTransactionCount: boolean = false,
  transactionTabName: string,
) => {
  // TODO: in mobile will go with old parser on desktop go with new parse logic
  const isLargeScreen = Dimensions.get('window').width > 550
  const isMobileScreen = isMobile(isLargeScreen)
  if (transactionTabName !== 'Transactions' && transactionTabName !== 'Home' && !isMobileScreen) {
    const respData = transactionsParserV3New(data, type, restrictTransactionCount)
    return respData
  } else {
    const respData = transactionsParserV3(data, type, restrictTransactionCount)
    return respData
  }
}

const transactionReqV3 = (
  tokens: any,
  userAccessToken: string,
  requestBody: any,
  type: any,
  restrictTransactionCount: boolean = false,
  isCustomFromRecent = false,
  transactionTabName = '',
  selectedDateInfo: any = null,
  abortController?: any,
) => {
  const isCustomRange =
    selectedDateInfo?.dateLabel === actionMenuStrings.customDate || selectedDateInfo?.dateLabel === 'custom'
  const isInfiniteDateScroll = selectedDateInfo?.dateLabel === actionMenuStrings.infiniteScrollRange

  const reqBody =
    isCustomRange || isCustomFromRecent || isInfiniteDateScroll
      ? requestBody
      : updateEndDateTimeInRequest(requestBody, selectedDateInfo)
  if (
    !!RootStore.settings.metaData.searchText &&
    shouldShowDateForSearch(RootStore.settings.metaData.searchFilterItem)
  ) {
    const fromDate = new Date(RootStore.transactions.selectedDateInfo.fromDate)
    const toDate = new Date(RootStore.transactions.selectedDateInfo.toDate)
    const formattedFilteredFromData = `${dateFormatter(fromDate, DateFormatTypes.YYYYMMDD)}${getHHMMSS(fromDate)}`
    const formattedFilteredToDateDate = `${dateFormatter(toDate, DateFormatTypes.YYYYMMDD)}${getHHMMSS(toDate)}`
    reqBody.inputFilter.startDateTime = formattedFilteredFromData
    reqBody.inputFilter.endDateTime = formattedFilteredToDateDate
  }
  const request: Request<{}> = {
    apiPath: APIEndPoints.TransactionsV3,
    method: 'POST',
    config: sitConfig(tokens, abortController),
    headers: {
      'Content-Type': 'application/json',
      Authorization: userAccessToken,
    },
    body: reqBody,
    cache: false,
  }
  return executeRequest(request).then((data) => {
    return responseParser(data, type, restrictTransactionCount, transactionTabName)
  })
}

export { transactionReqV3 }
